var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat"},[(_vm.chatOpen)?_c('div',{staticClass:"chat__overlay",on:{"click":function($event){_vm.chatOpen = false}}}):_vm._e(),_c('ChatContent',{staticClass:"chat__content",class:{
      'chat__content--open': _vm.chatOpen,
    }}),_c('div',{staticClass:"chat__button chat-button",on:{"click":function($event){_vm.chatOpen = !_vm.chatOpen}}},[_c('div',{staticClass:"chat-button__icon"},[_c('FileIconComponent',{staticClass:"chat-button__svg",attrs:{"name":"message-lines"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }